var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPlaced(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    fill: "#68B4DC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1583 5.24744C9.74271 4.88375 9.11095 4.92587 8.74727 5.34151C8.38359 5.75715 8.4257 6.38891 8.84134 6.75259L9.8384 7.62501H5C4.44772 7.62501 4 8.07273 4 8.62501C4 9.1773 4.44772 9.62501 5 9.62501H9.8384L8.84134 10.4974C8.4257 10.8611 8.38359 11.4929 8.74727 11.9085C9.11095 12.3242 9.74271 12.3663 10.1583 12.0026L13.1583 9.37759C13.3754 9.1877 13.4998 8.91338 13.4998 8.62501C13.4998 8.33665 13.3754 8.06233 13.1583 7.87244L10.1583 5.24744Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlaced);
export default __webpack_public_path__ + "static/media/icon-placed.ce152aed51ceb30d02d70166d1ac53ca.svg";
export { ForwardRef as ReactComponent };